<template>
  <svg :class="'icon'" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M17.5336 15.3372C18.1555 15.9597 18.1555 16.928 17.5336 17.5504C17.2226 17.8617 16.8426 18 16.428 18C16.0134 18 15.6334 17.8617 15.3225 17.5504L9 11.2219L2.67754 17.5504C2.3666 17.8617 1.98656 18 1.57198 18C1.15739 18 0.777351 17.8617 0.466411 17.5504C-0.15547 16.928 -0.15547 15.9597 0.466411 15.3372L6.78887 9.00865L0.466411 2.68012C-0.15547 2.05764 -0.15547 1.08934 0.466411 0.466859C1.08829 -0.15562 2.05566 -0.15562 2.67754 0.466859L9 6.79539L15.3225 0.466859C15.9443 -0.15562 16.9117 -0.15562 17.5336 0.466859C18.1555 1.08934 18.1555 2.05764 17.5336 2.68012L11.2111 9.00865L17.5336 15.3372Z"
      :fill="color"
    />
  </svg>
</template>

<script setup>
defineProps({
  /**
   * color of the icon
   */
  color: {
    type: String,
    default: '#000000', // Set your desired default color
  },
})
</script>

<style lang="scss" scoped></style>
